'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _validationConstants = require('../../validationConstants');

var EMAIL_ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.email,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    debounced: true,
    message: 'Not a valid email'
};

var getErrorObject = function getErrorObject(fieldValue, validationConfig) {
    return _extends({}, EMAIL_ERROR_OBJECT, {
        value: fieldValue,
        hideBeforeSubmit: !!validationConfig.hideBeforeSubmit
    });
};

exports.default = function (fieldValue, validationConfig) {
    if (!fieldValue) return null;
    if (!fieldValue.match(_validationConstants.EMAIL_REGEX)) return getErrorObject(fieldValue, validationConfig);
    return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/emailValidator.js
// module id = 2304
// module chunks = 0